import { createAsyncThunk, createSelector, createSlice } from "@reduxjs/toolkit";
import { MyListApi } from "../utils/restApi";

const TAGS_PER_PAGE = 99;
const MAX_TAG_PAGES = 100;

// Fetches every page of /api/v2/tags (PageData: items, page, count,
// maxPageCount) so categories are never silently truncated.
export const fetchAllTagPages = async (getTags = MyListApi.getTags, perPage = TAGS_PER_PAGE) => {
    const items = [];
    let page = 0;
    let maxPageCount = 1;
    do {
        const data = await getTags(page, perPage);
        items.push(...(data?.items || []));
        maxPageCount = typeof data?.maxPageCount === 'number' ? data.maxPageCount : 0;
        page++;
    } while (page < maxPageCount && page < MAX_TAG_PAGES);
    return items;
}

const parseDataInfo = dataInfo => {
    if (Array.isArray(dataInfo)) return dataInfo;
    try {
        const parsed = JSON.parse(dataInfo);
        return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
        return [];
    }
}

export const fetchTags = createAsyncThunk('tags/fetchTags', async () => {
    const items = await fetchAllTagPages();
    items.forEach(e => e.data_info = parseDataInfo(e.dataInfo));
    return items;
});

export const tagsSlice = createSlice({
    name: 'tags',
    initialState: {
        tags: [],
        status: 'idle',
        error: null,
    },
    reducers: {
        // Allows a retry after an error.
        resetTags: (state) => {
            state.status = 'idle';
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTags.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchTags.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.tags = action.payload;
            })
            .addCase(fetchTags.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error.message;
            });
    }
});

export const { resetTags } = tagsSlice.actions;

// Existing visibility rule: system tags are never offered as categories.
export const selectVisibleTags = createSelector(
    state => state.tags.tags,
    tags => tags.filter(t => !t.system),
);

export default tagsSlice.reducer;
